import Logger from "./Logger";
import WrapperMessageDispatcher from "./WrapperMessageDispatcher";
import StringFormatter from "./StringFormatter";
const TAG = 'ErrorHandlingUtils';
export default class UserNotificationUtils {
    static enableNotificationsGlobally() {
        UserNotificationUtils.notificationsGloballyEnabled = true;
    }
    static disableNotificationsGlobally() {
        UserNotificationUtils.notificationsGloballyEnabled = false;
    }
    static showSuccess(notificationMessage) {
        UserNotificationUtils.dispatchShowNotification(notificationMessage, 'SUCCESS');
    }
    static showError(notificationMessage, error) {
        const message = this.getErrorMessage(notificationMessage, error);
        UserNotificationUtils.dispatchShowNotification(message, 'ERROR');
    }
    static showPersistentError(notificationMessage, error) {
        const message = this.getErrorMessage(notificationMessage, error);
        UserNotificationUtils.dispatchShowNotification(message, 'PERSISTENT_ERROR');
    }
    static getErrorMessage(notificationMessage, error) {
        let extraText = '';
        if (error) {
            if (error.parameters && error.parameters['description']) {
                extraText = '. ' + error.parameters['description'];
            }
            else {
                // TODO I18N
                extraText = ' (' + StringFormatter(error.id, error.parameters) + ')';
            }
        }
        // TODO I18N
        return notificationMessage + extraText;
    }
    static showInfo(notificationMessage) {
        UserNotificationUtils.dispatchShowNotification(notificationMessage, 'INFO');
    }
    static showAdBlockError(notificationMessage) {
        UserNotificationUtils.dispatchShowNotification(notificationMessage, 'ADBLOCKER_ERROR');
    }
    static dispatchShowNotification(notificationMessage, notificationType) {
        if (!UserNotificationUtils.notificationsGloballyEnabled) {
            Logger.debug(TAG, `Notifications are currently disabled, not showing '${notificationMessage}' to the user as ${notificationType}...`);
            return;
        }
        Logger.debug(TAG, `Showing '${notificationMessage}' to the user as ${notificationType}...`);
        WrapperMessageDispatcher.dispatchMessage('show_notification', {
            notificationType: notificationType,
            notificationMessage: notificationMessage,
        });
    }
}
UserNotificationUtils.notificationsGloballyEnabled = true;
//# sourceMappingURL=UserNotificationUtils.js.map